import { useMutation } from '@tanstack/react-query';
import {
  GenerateBenchmarkBody,
  GenerateMultiOrPlanBody,
  GeneratePartialPlanBody,
  StartSurgeonTripsGenerationBody,
} from '@/api/apis/mission-planner';
import { api } from '@/api';

export const useCreateBenchmarkRoute = () => {
  return useMutation({
    mutationFn: (data: GenerateBenchmarkBody) => api.missionPlanner.createBenchmarkRoute(data),
  });
};

export const useCreateFullRouteList = () => {
  return useMutation({
    mutationFn: (data: GenerateMultiOrPlanBody) => api.missionPlanner.createFullRoutesList(data),
  });
};

export const useStartSurgeonRouteList = () => {
  return useMutation({
    mutationFn: ({ taskId, forcedSurgeonId }: StartSurgeonTripsGenerationBody & { taskId: string }) =>
      api.missionPlanner.startSurgeonTripsGeneration(taskId, forcedSurgeonId ? { forcedSurgeonId } : undefined),
  });
};

export const useStartCommercialFlightsList = () => {
  return useMutation({
    mutationFn: (taskId: string) => api.missionPlanner.startCommercialFlightsGeneration(taskId),
  });
};

export const useGeneratePartialRoute = () => {
  return useMutation({
    mutationFn: (data: GeneratePartialPlanBody) => api.missionPlanner.generatePartialRoute(data),
  });
};

export const useGeneratePartialCommercialFlights = () => {
  return useMutation({
    mutationFn: (taskId: string) => api.missionPlanner.generatePartialCommercialFlights(taskId),
  });
};
